var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.432)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.857,22H2.143A2.154,2.154,0,0,1,0,19.84V6.16A2.154,2.154,0,0,1,2.143,4H4V6.666A1.426,1.426,0,0,0,5.5,8,1.425,1.425,0,0,0,7,6.666V4H4V1.334A1.426,1.426,0,0,1,5.5,0,1.426,1.426,0,0,1,7,1.334V4h6V6.666A1.426,1.426,0,0,0,14.5,8,1.425,1.425,0,0,0,16,6.666V4H13V1.334A1.426,1.426,0,0,1,14.5,0,1.426,1.426,0,0,1,16,1.334V4h1.857A2.154,2.154,0,0,1,20,6.16V19.84A2.154,2.154,0,0,1,17.857,22ZM11,14v5h5V14Z",
    transform: "translate(0.432)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon-calendar.569c708dc8ac114397e878c0a8020f6e.svg";
export { ForwardRef as ReactComponent };